/**
 * Records the last meaningful user interaction so an error report can say WHAT
 * the user did right before it happened (e.g. "click: Save order (button)").
 *
 * Passive, capture-phase, best-effort — it never throws and never blocks the
 * event. One global listener, installed once from installGlobalErrorHandlers().
 */

let lastInteraction = null;

const ACTIONABLE = ["A", "BUTTON", "INPUT", "SELECT", "TEXTAREA"];

function describe(el) {
  if (!el || !el.tagName) return null;
  const tag = el.tagName.toLowerCase();
  const label =
    (typeof el.getAttribute === "function" && el.getAttribute("aria-label")) ||
    (el.innerText || el.textContent || "").trim().slice(0, 60) ||
    (typeof el.getAttribute === "function" && el.getAttribute("name")) ||
    (typeof el.getAttribute === "function" && el.getAttribute("title")) ||
    el.id ||
    "";
  const role =
    (typeof el.getAttribute === "function" && el.getAttribute("role")) || tag;
  return `click: ${label || "(unlabelled)"} (${role})`;
}

export function installBreadcrumbs() {
  if (typeof window === "undefined") return;

  window.addEventListener(
    "click",
    (e) => {
      try {
        // Walk up to the nearest actionable element for a useful label.
        let el = e.target;
        for (let i = 0; i < 4 && el; i++) {
          const hasRole =
            typeof el.getAttribute === "function" && el.getAttribute("role");
          if (ACTIONABLE.includes(el.tagName) || hasRole) break;
          el = el.parentElement;
        }
        lastInteraction = describe(el || e.target);
      } catch (_) {
        // never let breadcrumb capture affect the click
      }
    },
    { capture: true, passive: true }
  );
}

export function getLastInteraction() {
  return lastInteraction;
}
